package com.example.mystybag.permissionsUtils.expected

import androidx.compose.runtime.Composable
import com.example.mystybag.core.expected.Activity
import com.example.mystybag.core.expected.sharedActivity

expect object PermissionHelper {
    fun hasPermission(permission: Permission): Boolean
    suspend fun requestPermission(permission: Permission, activity: Activity = sharedActivity): Boolean
    @Composable
    fun PermissionView()
}

enum class Permission {
    CaptureImage,
    RecordVideo,
    Contacts,
    OpenGallery,
    WriteExternalStorage,
    Location,
    Notification
}